import { render, staticRenderFns } from "./3.vue?vue&type=template&id=392afb51&scoped=true&"
import script from "./3.vue?vue&type=script&lang=js&"
export * from "./3.vue?vue&type=script&lang=js&"
import style0 from "./3.vue?vue&type=style&index=0&id=392afb51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392afb51",
  null
  
)

export default component.exports